import React from 'react'
import YouTube from 'react-youtube'
import { useYoutubeAnalytics } from '@fs/zion-analytics'
import { i18n } from '@fs/zion-locale'
import type { YoutubePlayerProps } from '../types/YoutubePlayer'

export const YoutubePlayer = ({
  autoplay = false,
  disableControls = false,
  start = 0,
  isLive = false,
  aspectRatio = '16 / 9',
  opts,
  onStateChange,
  loop = false,
  ...props
}: YoutubePlayerProps): React.JSX.Element => {
  const onAnalyticsStateChange = useYoutubeAnalytics(isLive)
  const defaultOpts = {
    height: '100%',
    width: '100%',
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: autoplay ? 1 : 0,
      start,
      hl: i18n.language,
      cc_lang_pref: i18n.language,
      controls: disableControls ? 0 : 1,
      rel: 0,
      loop: loop ? 1 : 0,
      playlist: loop ? props.videoId : undefined,
    },
    ...opts,
  }

  const onChange = (event): void => {
    onAnalyticsStateChange(event)
    onStateChange?.(event)
  }

  return <YouTube style={{ aspectRatio }} opts={defaultOpts} onStateChange={onChange} {...props} />
}
